export enum TemplateModuleType {
  header = 'header',
  leadText = 'leadText',
  image = 'image',
  article = 'article',
  twoColumnImage = 'twoColumnImage',
  restOfArticles = 'restOfArticles',
  footer = 'footer',
  section = 'section',
  sponsored = 'sponsored',
  event = 'event',
  survey = 'survey',
  topicPreferences = 'topicPreferences',
}

export enum SectionConfig {
  SECTION_FONT_COLOR = 'sectionFontColor',
  SECTION_FONT_SIZE = 'sectionFontSize',
  SECTION_FONT_WEIGHT = 'sectionFontWeight',
  SECTION_SHOW_HEADER = 'sectionShowHeader',
  SECTION_BORDER_COLOR = 'sectionBorderColor',
  SECTION_BORDER_SIZE = 'sectionBorderSize',
}

export enum EventConfig {
  EVENT_FONT_COLOR = 'eventFontColor',
  EVENT_FONT_SIZE = 'eventFontSize',
  EVENT_FONT_WEIGHT = 'eventFontWeight',
  EVENT_SHOW_HEADER = 'eventShowHeader',
  EVENT_HEADER_TEXT = 'eventHeaderText',
  EVENT_BORDER_COLOR = 'eventBorderColor',
  EVENT_BORDER_SIZE = 'eventBorderSize',
}

export enum SurveyConfig {
  SURVEY_QUESTION_FONT_COLOR = 'surveyQuestionFontColor',
  SURVEY_QUESTION_FONT_SIZE = 'surveyQuestionFontSize',
  SURVEY_QUESTION_FONT_WEIGHT = 'surveyQuestionFontWeight',
  SURVEY_ANSWER_FONT_COLOR = 'surveyAnswerFontColor',
  SURVEY_ANSWER_FONT_SIZE = 'surveyAnswerFontSize',
  SURVEY_ANSWER_FONT_WEIGHT = 'surveyAnswerFontWeight',
  SURVEY_BORDER_COLOR = 'surveyBorderColor',
  SURVEY_BORDER_SIZE = 'surveyBorderSize',
}

export interface ModuleConfig {
  count?: number,
  end?: number,
  start?: number,
  isScheduled?: boolean,
  sectionId?: number,
  readMore?: string,
  [SectionConfig.SECTION_FONT_COLOR]?: string,
  [SectionConfig.SECTION_FONT_SIZE]?: string,
  [SectionConfig.SECTION_FONT_WEIGHT]?: string,
  [SectionConfig.SECTION_SHOW_HEADER]?: string,
  [SectionConfig.SECTION_BORDER_COLOR]?: string,
  [SectionConfig.SECTION_BORDER_SIZE]?: string,
  [EventConfig.EVENT_FONT_COLOR]?: string,
  [EventConfig.EVENT_FONT_SIZE]?: string,
  [EventConfig.EVENT_FONT_WEIGHT]?: string,
  [EventConfig.EVENT_SHOW_HEADER]?: string,
  [EventConfig.EVENT_HEADER_TEXT]?: string,
  [EventConfig.EVENT_BORDER_COLOR]?: string,
  [EventConfig.EVENT_BORDER_SIZE]?: string,
  [SurveyConfig.SURVEY_QUESTION_FONT_COLOR]?: string,
  [SurveyConfig.SURVEY_QUESTION_FONT_SIZE]?: string,
  [SurveyConfig.SURVEY_QUESTION_FONT_WEIGHT]?: string,
  [SurveyConfig.SURVEY_ANSWER_FONT_COLOR]?: string,
  [SurveyConfig.SURVEY_ANSWER_FONT_SIZE]?: string,
  [SurveyConfig.SURVEY_ANSWER_FONT_WEIGHT]?: string,
  [SurveyConfig.SURVEY_BORDER_COLOR]?: string,
  [SurveyConfig.SURVEY_BORDER_SIZE]?: string,
}

export interface TemplateModule {
  hidden: boolean,
  type: TemplateModuleType,
  isFirstArticleModule?: boolean,
  isManuallyAdded?: boolean,
  moduleConfig: ModuleConfig,
  sequence: number,
}
